// @shared

import catalog from "./shopCatalog.json"
import type { ShopItem } from "./shopTypes"

/**
 * Единый каталог магазина для интерфейса, покупок и подарков недели.
 * Новый предмет достаточно добавить в shopCatalog.json — сервер автоматически
 * включит его в подходящую ценовую группу подарка.
 */
export const SHOP_CATALOG = catalog as ShopItem[]

export function getShopItem(id: string): ShopItem | null {
  return SHOP_CATALOG.find((item) => item.id === id) ?? null
}
